module.exports = __webpack_public_path__ + "static/img/delete_icon.f872362c.svg";